export default "__VITE_ASSET__150660ea__"